import { render } from "./WhatWeDo.vue?vue&type=template&id=62b72430&ts=true"
import script from "./WhatWeDo.vue?vue&type=script&lang=ts"
export * from "./WhatWeDo.vue?vue&type=script&lang=ts"

import "./WhatWeDo.vue?vue&type=style&index=0&id=62b72430&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__